// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2wYLm","productName":"Table_productName__18h8H"};